__turbopack_context__.v({
  "banner": "styles-module__oJ7tsq__banner",
  "content": "styles-module__oJ7tsq__content",
  "dismissButton": "styles-module__oJ7tsq__dismissButton",
  "image": "styles-module__oJ7tsq__image",
  "link": "styles-module__oJ7tsq__link",
});
